<template>
  <v-app>
    <span class="bg"></span>
    <v-main>
      <v-container  class="fill-height">
        <v-row justify="center" align="stretch" no-gutters>
          <v-col cols="10" md="5" class="justify-center align-center">
            <v-card >
              <div class="page-bg">
                <div class="pt-5 text-center">
                  <v-avatar size="120">
                    <img :src="avatarImage" />
                  </v-avatar>
                </div>
                <div class="page-title text-center">
                  Maintenance Notice <br />
                </div>
                <div class="page-content">
                  <br />
                  &nbsp;&nbsp;Dear Revelio Planning User: <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sorry, the system you are trying to access is currently under 
                  &nbsp;&nbsp;maintenance. Please check back later or 
                  <a href="https://nielsenconnect.service-now.com/ess?id=sc_cat_item&sys_id=4fbb226adbfb495456e39dc3ca9619e4&sysparm_category=680c2aeadbfb495456e39dc3ca9619ba">Raise a SNOW ticket</a> 
                  if you 
                  &nbsp;&nbsp;need further assistance. <br />
                  <br />
                  &nbsp;&nbsp; &nbsp;&nbsp; Thanks <br />
                  <br />
                </div>
                <div class="page-content" style="text-align: right;">
                  Global Finance BI team &nbsp;&nbsp;<br />
                  {{ new Date().getFullYear()}}.{{ new Date().getMonth() + 1}}.{{ new Date().getDate()}} &nbsp;&nbsp;
                </div> 
                <div style="text-align: right;">
                  <v-btn 
                    class = "primary" 
                    v-if="roleId == -1"
                    @click="goToMaintainPage"
                  >
                    Go To Maintain Page
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div class="bg-page-content">
          © {{ new Date().getFullYear() }} — Nielsen Consumer LLC. All Rights Reserved
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "SysMaintain",
  created() {
    this.roleId = this.user.Role;
    console.log(this.roleId)
  },
  computed: {
    ...mapState([
        // 'gapi',
        'user'
    ]),
  },
  data: () => ({
    roleId: null,
    avatarImage: require("@/assets/RP new.png")
  }),
  methods: {
    async goToMaintainPage() {
      this.$router.push(
        "/op/tables/maintenance"
      );
    },
  }
 };
</script>

<style scoped>
.page-bg {
  height: 100%;
  width: 100%;
  background-color: #FEFEFE;
}
.page-content {
  font-size: 14px;
  font-weight: blod;
  color: rgb(0, 0, 0);
}
.page-title {
  font-size: 25px;
  font-weight: blod;
  color: rgb(0, 0, 0);
}
.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #2D6DF6;
  background-size: cover;
  z-index: 0;
}
.bg-page-content {
  z-index: 1;
  font-size: 10px;
  color: rgb(248, 252, 252);
  display: inline;
  position: fixed;
  right: 0;
  bottom: 0;
}
</style>
